(function () {
  function animateCounter(el, target, suffix, duration) {
    var start = null;
    var startValue = 0;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      // easeOutQuad
      var eased = 1 - (1 - progress) * (1 - progress);
      var current = Math.floor(eased * (target - startValue) + startValue);
      el.textContent = current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target + suffix;
      }
    }

    requestAnimationFrame(step);
  }

  function parseNumericValue(text) {
    var match = text.match(/^(\d+)(.*)/);
    if (!match) return null;
    return {
      value: parseInt(match[1], 10),
      suffix: match[2]
    };
  }

  function initCounters(section) {
    var targets = [];

    var nutritionTop = section.querySelector('[class*="__nutrition-top"]');
    if (nutritionTop) {
      var parsed = parseNumericValue(nutritionTop.textContent.trim());
      if (parsed) targets.push({ el: nutritionTop, parsed: parsed });
    }

    var nutritionItems = section.querySelectorAll('[class*="__nutrition-item"] h3');
    nutritionItems.forEach(function (h3) {
      var parsed = parseNumericValue(h3.textContent.trim());
      if (parsed) targets.push({ el: h3, parsed: parsed });
    });

    targets.forEach(function (item) {
      animateCounter(item.el, item.parsed.value, item.parsed.suffix, 1600);
    });
  }

  document.querySelectorAll('[class*="benefits_"][class*="__nutrition"]').forEach(function (nutritionEl) {
    var section = nutritionEl.closest('section');
    if (!section) return;

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          initCounters(section);
          obs.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(section);
  });
})();
